
import { shallowRef, toValue, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { previousRoute, resolveBackLocation, routeWithBackLocation } from '../router/history.js'

export function useBackRoute(fallback){

    const getBackRoute = (key, defaultRoute) => {

        if(previousRoute.value[key] === undefined) {
            return defaultRoute
        }

        if(previousRoute.value[key].fullPath === '/'){
            return defaultRoute
        }
    
        return previousRoute.value[key].query
    }

    if (!fallback) return { getBackRoute }

    const router = useRouter()
    const route = useRoute()
    const backLocation = shallowRef()
    const withBackLocation = (destination) => routeWithBackLocation(router, destination, backLocation.value)

    watch([() => route.path, () => toValue(fallback)], ([, defaultRoute]) => {
        backLocation.value = resolveBackLocation({
            router,
            current: route,
            previous: previousRoute.value.original,
            state: typeof window === 'undefined' ? {} : window.history.state ?? {},
            fallback: defaultRoute,
        })

        if (backLocation.value && typeof window !== 'undefined') {
            window.history.replaceState({ ...window.history.state, ...withBackLocation(route).state }, '')
        }
    }, { immediate: true })

    return { getBackRoute, backLocation, withBackLocation }
}
